module.exports = __webpack_public_path__ + "img/pic_elf_02_R.b1ab9e6a.png";